module.exports = __webpack_public_path__ + "static/media/tick.561fe951.svg";